export default "__VITE_ASSET__bb4d6885__"